module.exports = __webpack_public_path__ + "img/img_10.d23b62f0.png";